module.exports = __webpack_public_path__ + "static/logo1-0ac193d0c74d96f363f37f980b2021ae.jpg";